import { render, staticRenderFns } from "./NegativeMarginSkusReport.vue?vue&type=template&id=22222771&"
import script from "./NegativeMarginSkusReport.vue?vue&type=script&lang=js&"
export * from "./NegativeMarginSkusReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports